import { render, staticRenderFns } from "./VentaRemisionConcepto.vue?vue&type=template&id=85fdee6a&"
import script from "./VentaRemisionConcepto.vue?vue&type=script&lang=js&"
export * from "./VentaRemisionConcepto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports